/**
 * Module Dependencies
 */
import gaap from './gaap'
import debt from './debt'
import capex from './capex'
import state from './state'
import equity from './equity'
import income from './income'
import actions from './actions'
import getters from './getters'
import activity from './activity'
import overview from './overview'
import cashflow from './cash-flow'
import rentRoll from './rent-roll'
import tearsheet from './tearsheet'
import devbudget from './devbudget'
import mutations from './mutations'
import otherIncome from './other-income'
import netProceeds from './net-proceeds'
import opexSummary from './opex-summary'
import opexSchedule from './opex-schedule'
import opexProForma from './opex-pro-forma'
import exitAssumptions from './exit-assumptions'
import sensitivityAnalysis from './sensitivity-analysis'

/**
 * Project Module Declaration
 *
 * @type {Object}
 */
const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules: {
        debt,
        gaap,
        capex,
        equity,
        income,
        rentRoll,
        overview,
        cashflow,
        activity,
        tearsheet,
        devbudget,
        otherIncome,
        netProceeds,
        opexSummary,
        opexSchedule,
        opexProForma,
        exitAssumptions,
        sensitivityAnalysis
    }
}

export default module



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/index.js